var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.logo},[_vm._v("𝖕𝖑𝖊𝖆𝖙𝖙")])}
var staticRenderFns = []

export { render, staticRenderFns }